import React from 'react';

export default function ErrorView(props) {
  return (
    <div className="abl-error-view">
      <img className="abl-error-image" src={require('../../../img/svg/error_image.svg')}
        alt="Sorry, there was an error" />
      <div className="abl-error-message-container">
        <h4>Sorry, something went wrong.</h4>
        <div className="abl-error-signature">
          Sincerely, <br /><br />
          Team Abl
        </div>
      </div>
    </div>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/error.js
 **/